import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

interface CompanyProfileErrorProps {
  error: Error | null
  onRetry?: () => void
}

export function CompanyProfileError({ error, onRetry }: CompanyProfileErrorProps) {
  const { t } = useTranslation()
  const msg = error?.message ?? ''
  const isNotFound = msg.includes('404') || msg.toLowerCase().includes('not found')

  return (
    <div className="flex h-[calc(100vh-8rem)] flex-col items-center justify-center gap-4">
      <p className="text-destructive">
        {isNotFound ? t('companies.errors.notFound') : t('companies.errors.loadFailed')}
      </p>
      <div className="flex gap-2">
        <Button asChild variant="outline">
          <Link to="/companies">{t('actions.back')}</Link>
        </Button>
        {onRetry && !isNotFound && <Button onClick={onRetry}>{t('actions.retry')}</Button>}
      </div>
    </div>
  )
}
